import React, { useEffect } from 'react';

import styles from './Frequency.module.css';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  scales: {
    // scaleShowLabels: false,
    x: {
      // <-- axis is not array anymore, unlike before in v2.x: '[{'
      grid: {
        color: '#666',
        // borderColor: 'red'  // <-- this line is answer to initial question
      },
      ticks: {
        color: '#ded9c4',
      },
      // display: false
    },
    y: {
      // <-- axis is not array anymore, unlike before in v2.x: '[{'
      grid: {
        color: '#666',
        // borderColor: 'green'  // <-- this line is answer to initial question
      },
      ticks: {
        color: '#666',
      },
      display: true,
    },
  },
  responsive: true,
  label: { display: true, color: 'blue' },
  plugins: {
    legend: {
      position: 'top',
      display: true,
      labels: {
        usePointStyle: true,
        boxWidth: 6,
        font: {size: 10},
        color: '#f2eedc' },
    },
    title: {
      display: false,
      text: 'Posts by month'
    },
  },
};

// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

// const data = {
//   labels,
//   datasets: [
//     {
//       label: 'Dataset 1',
//       data: [1, 5, 6, 7, 8, 4],
//       borderColor: 'rgb(255, 99, 132)',
//       backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//       label: 'Dataset 2',
//       data: [5, 1, 12, 2, 8, 3],
//       borderColor: 'rgb(53, 162, 235)',
//       backgroundColor: 'rgba(53, 162, 235, 0.5)',
//     },
//   ],
// };

// let lineChart = this.reference.chartInstance

const FrequencyLine = (props) => {
  // const [labelsArray, setLabelsArray] = useState();
  // const [datasetArray, setDatasetArray] = useState();

  useEffect(() => {
    console.log('pfA: ', props.data);
  }, [props.data]);

  return (
    <div className={styles.LineDiv}>
      {props.ready ? (
        <Line data={props.data} options={options} />
      ) : null}
    </div>
  );
};

export default FrequencyLine;
